import { InvoicingService } from './invoicing.service';
import {
  activationClasses, currentUrl,
  disabledElement, hiddenClasses, maximumNumber,
  numberSystemDecimal,
  searchParams
} from '../../common/consts';
import { InterfaceInvoiceLicense } from '../../interface/invoice/invoice.license';
import { isValidEmail, isValidPhone } from '../../common/expansion/handler-string';
import { InterfaceResultResponse } from '../../interface/result.response';
import { SliderCaptchaComponent } from '../../components/slider-captcha.comonent';
import { ModalComponent } from '../../base/modal/modal.component';
import { iconsSvg } from '../../common/comparison/editorial-board/icons-svg';
import { ServerHandler } from '../../common/server/serverHandler';

export class InvoicingPage {
  private invoicingService: InvoicingService;
  private readonly invoicingLicenses: HTMLElement | null;
  private invoicingCardLicenses: InterfaceInvoiceLicense[];
  private invoicingShowcaseItems: InterfaceInvoiceLicense[];
  private invoicingShowcaseChangeableItems: InterfaceInvoiceLicense[];
  private readonly licenseShowcaseRendered: HTMLElement | null;
  private idsSelectedLicenses: number[];
  private readonly modalOpen: HTMLElement | null;
  private stateCartItems: any[];
  private readonly totalPrice: HTMLElement | null;
  private readonly checkEmailButton: HTMLElement | null;
  private readonly maxInputNumber: number;
  private readonly inputEmail: HTMLInputElement | null;
  private readonly inputCodeEmail: HTMLInputElement | null;
  private readonly noteCodeEmail: HTMLElement | null;
  private guidConfirmEmail: string;
  private readonly resendButton: HTMLElement | null;
  private countdown: HTMLElement | null;
  private referenceIntervalIndex: ReturnType<typeof setInterval> | null;
  private isResend: boolean;
  private isEntryEmailCode: boolean;
  private readonly successfulEmailConfirmation: HTMLElement | null;
  private noteCodeEmailResend: HTMLElement | null;
  private inputs: HTMLInputElement[];
  private classes: {
    [category: string]: {
      [className: string]: string;
    };
  };
  private checkboxAgreeWrapItems: HTMLElement[];
  private sliderCaptcha: SliderCaptchaComponent | null;
  private captchaPassed: boolean;
  private isEmailConfirmed: boolean;
  private sendRequestManagerBtn: HTMLFormElement | null;
  private noValidationKpp: boolean;
  private countLicenses: HTMLElement | null;
  private sliderCaptchaHint: HTMLElement | null;
  private checkboxes: HTMLInputElement[];
  private invoicingButton: HTMLElement | null;

  constructor(
    private container: HTMLFormElement,
    private loader: HTMLElement | null,
    private modal: HTMLElement | null,
  ) {
    this.invoicingService = new InvoicingService(loader);
    this.invoicingLicenses = document.querySelector('[data-invoicing-licenses]');
    this.invoicingCardLicenses = [];
    this.invoicingShowcaseItems = [];
    this.invoicingShowcaseChangeableItems = [];
    this.idsSelectedLicenses = [];
    this.licenseShowcaseRendered = document.querySelector('[data-license-showcase-rendered]');
    this.modalOpen = document.querySelector('[data-modal-open="adding-agreement"]');
    this.stateCartItems = [];
    this.totalPrice = document.querySelector('[data-total-price]');
    this.checkEmailButton = container.querySelector('[data-check-email-button]');
    this.maxInputNumber = 9999;
    this.inputEmail = container.querySelector('[name="Email"]');
    this.inputCodeEmail = container.querySelector('[data-input-code-email]');
    this.noteCodeEmail = container.querySelector('[data-note-code-email]');
    this.guidConfirmEmail = '';
    this.resendButton = container.querySelector('[data-resend-button]');
    this.countdown = container.querySelector('[data-countdown]');
    this.referenceIntervalIndex = null;
    this.isResend = false;
    this.isEntryEmailCode = false;
    this.successfulEmailConfirmation = container.querySelector('[data-successful-email-confirmation]');
    this.noteCodeEmailResend = container.querySelector('[data-note-code-email-resend]');
    this.inputs = Array.prototype.slice.call(this.container.querySelectorAll('input'));
    this.classes = {
      margins: {
        small: 'margin-small',
        medium: 'margin-medium'
      },
      errors: {
        error: 'error'
      }
    };
    this.checkboxAgreeWrapItems = Array.prototype.slice.call(container.querySelectorAll('[data-checkbox-agree-wrap]'));
    this.sliderCaptcha = null;
    this.captchaPassed = false;
    this.isEmailConfirmed = false;
    this.sendRequestManagerBtn = container.querySelector('[data-send-request-manager]');
    this.noValidationKpp = false;
    this.countLicenses = document.querySelector('[data-count-licenses]');
    this.sliderCaptchaHint = container.querySelector('[data-slider-captcha-hint]');
    this.checkboxes = Array.prototype.slice.call(container.querySelectorAll('[type="checkbox"]'));
    this.invoicingButton = container.querySelector('[data-invoicing-button]');
  }

  public initialize(): void {
    const captchaContainer = this.container.querySelector('[data-slider-captcha]');
    if (captchaContainer) {
      const viewMessage = captchaContainer.querySelector('h6');
      this.sliderCaptcha = new SliderCaptchaComponent(
        captchaContainer as HTMLElement,
        this.invoicingService,
        () => {
          this.loader?.classList.add(activationClasses.active);
          this.invoicingService.verifyCaptcha(
            new FormData(),
          ).then((response: Response | null) => {
            if (response) {
              this.captchaPassed = ServerHandler.successAnswer(response.status);
              if (viewMessage) {
                viewMessage.textContent = '';
              }
              return response.json();
            }
          }).then((data: { message?: string }) => {
            if (!this.captchaPassed) {
              if (viewMessage && data.message) {
                viewMessage.textContent = data.message;
              }
              if (this.sliderCaptcha) {
                this.sliderCaptcha.loadNewCaptcha();
              }
            } else {
              if (this.sliderCaptchaHint && data.message === 'success') {
                this.sliderCaptchaHint.innerText = ''; // Капча пройдена
                this.sliderCaptchaHint.classList.add('green');
                if (this.sliderCaptcha) {
                  this.sliderCaptcha.lockCaptchaExternally();
                }
              }
            }
          }).finally(() => {
            this.loader?.classList.remove(activationClasses.active);
          });
        },
        (errorMessage) => {
          if (viewMessage) {
            viewMessage.textContent = errorMessage;
          }
        }
      );

      if (this.sliderCaptcha) {
        const current = this;
        setInterval(() => {

          current?.sliderCaptcha?.loadNewCaptcha();
          if (this.sliderCaptchaHint) {
            this.sliderCaptchaHint.innerText = 'Потяните ползунок, чтобы совместить пазл';
            this.sliderCaptchaHint.classList.remove('green');
          }
        }, 50 * 60 * 1000);
      }

      this.container.addEventListener('submit', async (event: Event) => {
        event.preventDefault();
        const isValidCheckboxes = this.validateCheckboxes();
        const idCaptchaPassed = this.checkCaptcha(viewMessage);
        const validateFields = this.validateFields();

        if (validateFields && isValidCheckboxes && idCaptchaPassed) {
          const formData = new FormData(this.container);
          await this.invoicingService.generateInvoice(formData).then(async (data: InterfaceResultResponse | null) => {

          if (data && data.Status === 1) {
            currentUrl.pathname = '/заказ-оформлен';
            const dataMessage = data.Message;
            if (dataMessage) {
              currentUrl.searchParams.set('orderId', dataMessage);
            }
            await this.invoicingService.sendRequestManager(formData).then((response: Response | null) => {

              if (response && this.modal && response.status >= 200 && response.status < 300) {
                // this.sliderCaptcha?.refreshCaptcha();
                window.location.href = currentUrl.toString();
              } else {
                if (this.modal) {
                  new ModalComponent(this.modal, null, 'application-server-error').initialize();
                }
              }
            });
          } else {
            if (this.modal) {
              new ModalComponent(this.modal, null, 'application-sent-error').initialize();
            }
          }
        });
          // this.checkboxes.forEach((checkbox: HTMLInputElement) => {
          //   if (checkbox.name === 'Promotion') {
          //     if (checkbox?.checked) {
          //       this.sendManager(formData);
          //     } else {
          //
          //     }
          //   }
          // });
        }
      });
      this.sendRequestManager(viewMessage);
    }

    this.renderInvoicingLicenses();
    document.addEventListener('modalContentRendered', this.handleModalContentRendered.bind(this) as EventListener);
    this.checkEmail();
    this.processFields();

    const inn = this.inputs.find(input => input.name === 'Inn');
    const kpp = this.inputs.find(input => input.name === 'Kpp');

    if (inn) {
      inn.addEventListener('input', () => {
        const isIndividual = inn.value.length > 10;
        if (isIndividual) {
          kpp?.setAttribute('disabled', 'disabled');
        } else {
          kpp?.removeAttribute('disabled');
        }
        this.noValidationKpp = isIndividual;
      });
    }
  }

  private sendRequestManager(viewMessage: HTMLElement | null):void {
    if (this.sendRequestManagerBtn) {
      this.sendRequestManagerBtn.addEventListener('click', () => {
        const isValidCheckboxes = this.validateCheckboxes();
        const idCaptchaPassed = this.checkCaptcha(viewMessage);
        const validateFields = this.validateFields();

        if (validateFields && isValidCheckboxes && idCaptchaPassed) {
          const formData = new FormData(this.container);
          formData.append('Manager', 'help');
          this.sendManager(formData);
        }
      });
    }
  }
  private sendManager(formData: FormData) {
    this.invoicingService.sendRequestManager(formData).then((response: Response | null) => {
      if (this.modal) {
        if (response && this.modal && response.status >= 200 && response.status < 300) {
          new ModalComponent(this.modal, null,'application-sent-successfully').initialize();
        } else {
          new ModalComponent(this.modal, null,'application-server-error').initialize();
        }
      }
    });
  }
  private processFields(): void {
    this.inputs.forEach((input: HTMLInputElement) => {
      if (input && input.name === 'Phone') {
        input.addEventListener('input', (e: Event) => {
          const target = e.target as HTMLInputElement;
          if (target) {
            target.value = target.value.replace(/[^\d+()-]/g, '');
          }
        });
      }
      if (input && (input.name === 'Kpp' || input.name === 'Inn') ) {
        input.addEventListener('input', (e: Event) => {
          const target = e.target as HTMLInputElement;
          if (target) {
            target.value = target.value.replace(/[^\d]/g, '');
          }
        });
      }
      if (input && input.name === 'Promotion') {
        input.addEventListener('input', (e: Event) => {
          const target = e.currentTarget as HTMLInputElement;
          if (this.invoicingButton) {
            if (target?.checked) {
              this.invoicingButton.setAttribute(disabledElement.disabled, disabledElement.disabled);
            } else {
              this.invoicingButton.removeAttribute(disabledElement.disabled);
            }
          }
        });
      }
    });
  }

  checkCaptcha(viewMessage: HTMLElement | null): boolean {

    if (!this.captchaPassed) {
      if (viewMessage) {
        viewMessage.textContent = 'Пройдите капчу';
      }
    }
    return this.captchaPassed;
  }

  private validateFields(): boolean {
    this.clearError();
    let isValid = true;
    this.inputs.forEach((input: HTMLInputElement) => {
      const elementText = input.nextElementSibling as HTMLElement;
      if (elementText) {
        const isWrap = input.closest('[data-input-wrap]') as HTMLElement | null;
        const inputItem = input.closest('[data-input-item]') as HTMLElement | null;

       const noValidationKpp = input.name === 'Kpp' && this.noValidationKpp;

        if (input.name == 'CodeEmail' && !this.isEmailConfirmed) {
          isValid = false;
        } else {
          if (input.value === '' && !noValidationKpp) {
            this.viewError(elementText, isWrap, inputItem, 'Обязательное поле', input);
            // isValid = false;
            isValid = input.name === 'Kpp' && this.noValidationKpp
          }
        }
        if (input.name === 'CodeEmail' && !this.isEmailConfirmed) {
          this.inputs.forEach((currentInput: HTMLInputElement) => {
            const inputItem = currentInput.closest('[data-input-item]') as HTMLElement | null;
            if (currentInput.name === 'Email' && currentInput.value !== '') {
              const viewMassage = currentInput.nextElementSibling as HTMLElement;
              if (viewMassage) {
                this.viewError(viewMassage, isWrap, inputItem, 'Подтвердите email', currentInput);
                if (!isValidEmail(currentInput.value)) {
                  this.viewError(viewMassage, isWrap, inputItem, 'Некорректный email', currentInput);
                }
              }
            }
          });
        }
        if (input.name === 'Email' && input.value !== '' && !isValidEmail(input.value)) {
          this.viewError(elementText, isWrap, inputItem, 'Некорректный email', input);
          isValid = false;
        }
        if (input.name === 'Phone' && input.value !== '' && !isValidPhone(input.value)) {
          this.viewError(elementText, isWrap, inputItem, 'Некорректно указан телефон', input);
          isValid = false;
        }
        if (input.name === 'Inn' && input.value !== '' && !this.validateInn(input.value)) {
          this.viewError(elementText, isWrap, inputItem, 'Некорректный ИНН', input);
          isValid = false;
        }
        if (input.name === 'Kpp' && input.value !== '' && !this.validateCorrectKpp(input.value)) {
          this.viewError(elementText, isWrap, inputItem, 'Некорректный КПП', input);
          isValid = false;
        }
        if (input.name === 'Kpp' && input.value !== '' && !this.validateReasonCode(input.value)) {
          this.viewError(elementText, isWrap, inputItem, 'Недопустимый код причины постановки на учет', input);
          isValid = false;
        }
      }
    });
    this.scrollToError();
    return isValid;
  }
  private scrollToError(): boolean {
    const inputs =  Array.prototype.slice.call(this.container.querySelectorAll('[data-input-item]'));

    for (const input of inputs) {
      if (input.classList.contains('error')) {
        input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        return true;
      }
    }
    return false;
  }
  private validateCheckboxes(): boolean {
    let isValid = true;
    this.checkboxAgreeWrapItems.forEach((cawi: HTMLElement) => {
      const checkbox = cawi.querySelector('input[type="checkbox"]') as HTMLInputElement;
      const viewTextError = cawi.querySelector('h6');
      if(viewTextError) {
        if (!checkbox?.checked) {
          isValid = false;
          viewTextError.innerText = 'Требуется подтверждение';
        } else {
          viewTextError.innerText = '';
        }
      }
    });

    return isValid;
  }

  private clearError() {
    this.inputs.forEach((input: HTMLInputElement) => {
      const elementText = input.nextElementSibling as HTMLElement;
      if (elementText) {
        const isWrap = input.closest('[data-input-wrap]') as HTMLElement | null;
        const inputItem = input.closest('[data-input-item]') as HTMLElement | null;

        elementText.classList.remove(activationClasses.active);
        isWrap?.classList.remove(this.classes.margins.medium);
        inputItem?.classList.remove(this.classes.errors.error);
      }
    });
  }

  private viewError(elementText: HTMLElement | null, isWrap: HTMLElement | null, inputItem: HTMLElement | null, text: string, input: HTMLInputElement | null) {
    if (elementText) {
      elementText.innerText = text;
    }
    elementText?.classList.add(activationClasses.active);
    isWrap?.classList.add(this.classes.margins.medium);
    inputItem?.classList.add(this.classes.errors.error);
  }

  private checkEmail() {
    if (this.checkEmailButton) {
      let codeEmail: string | null = null;
      this.checkEmailButton.addEventListener('click', () => {
        if (this.isEntryEmailCode && this.inputCodeEmail) {
          const field = this.inputCodeEmail.querySelector('[name="CodeEmail"]') as HTMLInputElement;
          if (field) {
            if (field.value !== codeEmail) {
              this.invoicingService.validateConfirmationCode(this.guidConfirmEmail, field.value)
                .then((response: InterfaceResultResponse) => {
                  codeEmail = field.value;
                  if (response.Status === 1) {
                    if (this.resendButton && this.noteCodeEmail && this.inputCodeEmail && this.noteCodeEmailResend) {
                      this.resendButton.classList.add(hiddenClasses.hidden);
                      this.resendButton.classList.remove(activationClasses.active);
                      this.noteCodeEmail.classList.add(hiddenClasses.hidden);
                      this.inputCodeEmail.classList.add(hiddenClasses.hidden);
                      // this.checkEmailButton?.removeAttribute('data-entry-email-code');
                      this.noteCodeEmailResend.classList.add(hiddenClasses.hidden);
                      const wrap = this.checkEmailButton?.closest('[data-input-wrap]');
                      if (wrap) {
                        wrap.classList.remove(this.classes.margins.small);
                      }
                      this.isEntryEmailCode = false;
                      if (this.checkEmailButton) {
                        this.checkEmailButton.remove();
                      }
                      if (this.successfulEmailConfirmation) {
                        this.successfulEmailConfirmation.classList.remove('hidden');
                        this.inputs.forEach((input: HTMLInputElement) => {
                          if (input.name === 'Email') {
                            input.setAttribute('readonly', '');
                          }
                        });
                      }
                    }
                    this.setInputsError('Email', '');
                    this.setInputsError('CodeEmail', '');
                    this.isEmailConfirmed = true;
                  }
                  if (response.Status === 2) {
                    this.setInputsError('CodeEmail', 'Неверный код');
                  }
                });
            }
          }
        } else {
          this.sendConfirmationCode();
        }
      });
    }
    if (this.resendButton) {
      this.resendButton.addEventListener('click', () => {
        if (this.isResend) {
          this.sendConfirmationCode(true);
          this.isResend = false;
        }
      });
    }
  }

  private sendConfirmationCode(isRepeat: boolean = false) {
    if (this.inputEmail) {
      const inputEmailValue = this.inputEmail.value;
      if (inputEmailValue && isValidEmail(inputEmailValue)) {
        this.invoicingService.confirmCodeEmail(inputEmailValue).then((response: InterfaceResultResponse | null) => {
          if (this.inputCodeEmail) {
            this.inputCodeEmail.classList.remove(hiddenClasses.hidden);
          }
          if (this.noteCodeEmail) {
            this.noteCodeEmail.classList.remove(hiddenClasses.hidden);
            const textRepeat = isRepeat ? 'повторно': '';
            this.noteCodeEmail.innerText = `Мы ${textRepeat} отправили код подтверждения на ${inputEmailValue}`;
          }
          if (this.noteCodeEmailResend) {
            this.noteCodeEmailResend.classList.remove(hiddenClasses.hidden);
          }
          if (this.checkEmailButton) {
            this.checkEmailButton.innerText = 'Ок';
            // this.checkEmailButton.setAttribute('data-entry-email-code', '');
            this.isEntryEmailCode = true;
            const wrap = this.checkEmailButton.closest('[data-input-wrap]');
            if (wrap) {
              wrap.classList.add(this.classes.margins.small);
            }
          }
          if (response) {
            this.guidConfirmEmail = response.Data;
          }
          let countdownTime = 120;

          if (this.referenceIntervalIndex) {
            clearInterval(this.referenceIntervalIndex);
          }

          if (this.countdown && this.resendButton) {
            this.resendButton.classList.remove(hiddenClasses.hidden);
            this.countdown.innerText = this.formatTime(countdownTime);
            this.resendButton.classList.remove(activationClasses.active);
            const current = this;
            this.referenceIntervalIndex = setInterval(() => {
              countdownTime--;
              if (current.countdown) {
                current.countdown.innerText = this.formatTime(countdownTime);
              }
              if (countdownTime <= 0) {
                current.isResend = true;
                if (current.referenceIntervalIndex) {
                  clearInterval(current.referenceIntervalIndex);
                }
                if (this.noteCodeEmail) {
                  this.noteCodeEmail.innerText = '';
                }
                if (current.countdown && current.resendButton) {
                  current.countdown.innerText = '';
                  current.resendButton.classList.add(activationClasses.active);
                }
              }
            }, 1000);
          }
        });
      } else {
        this.setInputsError('Email', 'Некорректный email');
      }
    }
  }

  setInputsError(name: string, textError: string = '') {
    this.inputs.forEach((input: HTMLInputElement) => {
      if (input.name === name) {
        const elementText = input.nextElementSibling as HTMLElement;
        if (elementText) {
          const isWrap = input.closest('[data-input-wrap]');
          const inputItem = input.closest('[data-input-item]');

          if (textError) {
            elementText.innerText = textError;
            elementText.classList.add(activationClasses.active);
            isWrap?.classList.add(this.classes.margins.medium);
            inputItem?.classList.add(this.classes.errors.error);
          } else {
            elementText.classList.remove(activationClasses.active);
            isWrap?.classList.remove(this.classes.margins.medium);
            inputItem?.classList.remove(this.classes.errors.error);
          }
        }
      }
    });
  }

  private formatTime(timeInSeconds: number) {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  private changeShowcaseLicense(): void {
    this.invoicingShowcaseChangeableItems = this.invoicingShowcaseItems.filter((isi: InterfaceInvoiceLicense) =>
      !this.idsSelectedLicenses.some((isl: number) => isl === isi.Id)
    );
    if (this.modalOpen) {
      if (this.invoicingShowcaseChangeableItems.length === 0) {
        this.modalClose();
        this.modalOpen.setAttribute(disabledElement.disabled, 'true');
        this.modalOpen.classList.add(disabledElement.disabled);
      } else {
        this.modalOpen.removeAttribute(disabledElement.disabled);
        this.modalOpen.classList.remove(disabledElement.disabled);
      }
    }
  }

  private modalClose() {
    const event = new CustomEvent('modalClose', {});
    document.dispatchEvent(event);
  }

  private showcaseRender(container: HTMLElement | null = null) {
    let result = '';
    this.invoicingShowcaseChangeableItems.forEach((ilsi: InterfaceInvoiceLicense) => {

      result += `
        <div
            class="invoicing__edition invoicing__edition--pointer invoicing__cart-items"
            data-license-showcase-id="${ilsi.Id}"
            data-license-showcase-price="36000"
        >
          <div class="invoicing__icon-title invoicing__icon-title--width">
            ${iconsSvg[ilsi.Id]}
            <div class="invoicing__cart-item">
              <h6 class="gray mb-10">Редакция</h6>
              <p>
                ${ilsi.Edition}
              </p>
            </div>
          </div>
          <div class="invoicing__control-many">
            <div class="invoicing__cart-item invoicing__cart-item--align-right mb-15">
              <h6 class="gray mb-10">Стоимость, руб</h6>
              <h5>${ilsi.Price.toLocaleString('ru')}</h5>
            </div>
          </div>
        </div>
        `;
    });
    if (this.licenseShowcaseRendered) {
      this.licenseShowcaseRendered.innerHTML = result;
    }
    if (container) {
      const licenseShowcaseRendered = container.querySelector('[data-license-showcase-rendered]');
      if (licenseShowcaseRendered) {
        licenseShowcaseRendered.innerHTML = result;
      }
      this.initSelectLicense(container);
    }
  }

  private changeCardLicense() {
    this.invoicingCardLicenses = this.invoicingShowcaseItems.filter((isi: InterfaceInvoiceLicense) =>
      this.idsSelectedLicenses.includes(isi.Id)
    );
    this.idsSelectedLicenses.forEach((isl: number) => {
      if (!this.stateCartItems.some(sbi => isl === sbi.id)) {
        const invoicingCardLicense = this.invoicingCardLicenses.find(icl => icl.Id === isl);
        if (invoicingCardLicense) {
          this.stateCartItems.push({ id: isl, count: 1, price: invoicingCardLicense.Price });
        }
      }
    });
    this.stateCartItems = this.stateCartItems.filter(sbi => this.idsSelectedLicenses.includes(sbi.id));
    this.displayTotalPrice();
  }

  private displayTotalPrice() {
    let total = 0;
    let totalCount = 0;
    this.stateCartItems.forEach(sbi => {
      total += Math.abs(sbi.price);
      totalCount += Math.abs(sbi.count);
    });
    if (this.totalPrice) {
      const showPrice = this.totalPrice.querySelector('h4');
      if (showPrice) {
        showPrice.innerText = total.toLocaleString('ru') + ' ₽';
        if (this.countLicenses) {
          this.countLicenses.innerText = String(totalCount);
        }
      }
    }
  }

  private handleModalContentRendered(event: Event): void {
    const customEvent = event as CustomEvent<{ container: HTMLElement }>;
    const { container } = customEvent.detail;

    this.initSelectLicense(container);
    const licensesConfirmation = container.querySelector('[data-licenses-confirmation]');
    if (licensesConfirmation) {
      licensesConfirmation.addEventListener('click', () => {
        this.modalClose();
      });
    }
  }

  initSelectLicense(container: HTMLElement) {
    const licenseShowcaseIds = Array.prototype.slice.call(container.querySelectorAll('[data-license-showcase-id]'));
    licenseShowcaseIds.forEach((lsi: HTMLElement) => {
      lsi.addEventListener('click', (e: Event) => {
        e.stopPropagation();
        const id = lsi.dataset.licenseShowcaseId;
        if (id) {
          const currentId = parseInt(id, numberSystemDecimal);
          if (!this.idsSelectedLicenses.includes(currentId)) {
            this.idsSelectedLicenses.push(currentId);
          }
          this.changeShowcaseLicense();
          this.showcaseRender(container);
          this.changeCardLicense();
          this.cartRender();
        }
      });
    });
  }

  private cartRender() {
    let result = '';
    this.invoicingCardLicenses.forEach((iec: InterfaceInvoiceLicense, index: number) => {
      const stateCart = this.stateCartItems.find(sbi => sbi.id === iec.Id);
      result += `
        <div class="invoicing__edition mb-30">
          <div class="invoicing__icon-title">
            ${iconsSvg[iec.Id]}
            <div class="invoicing__cart-items">
              <div>
                <h6 class="gray mb-10">Редакция</h6>
                <p>
                   ${iec.Edition}
                </p>
              </div>
              <div class="invoicing__control-many">
                <div class="invoicing__cart-item">
                  <h6 class="gray mb-10">Кол-во</h6>
                  <div class="invoicing__cart-count-control" data-cart-count-control="${iec.Id}">
                    <div class="invoicing__cart-count-control-item" data-lisense-minus >
                      <svg width="16" height="3" viewBox="0 0 16 3" fill="none"
                           xmlns="http://www.w3.org/2000/svg" >
                        <path d="M1.14258 1.14062H14.8569" stroke="#8B8B8B"
                              stroke-width="2.28571" stroke-linecap="round"
                              stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <input type="hidden" name="Licenses[${index}][licenseId]" value="${iec.Id}">
                    <input value="${stateCart.count}" type="text" name="Licenses[${index}][quantity]" maxlength="4"/>
                    <div data-lisense-plus class="invoicing__cart-count-control-item">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.7959 0C8.4111 0.000241161 8.91016 0.499004 8.91016 1.11426V6.68555H14.4844C15.0996 6.6858 15.5986 7.18456 15.5986 7.7998C15.5986 8.41505 15.0996 8.91381 14.4844 8.91406H8.91016V14.4863C8.91007 15.1015 8.41104 15.6003 7.7959 15.6006C7.18055 15.6006 6.68173 15.1017 6.68164 14.4863V8.91406H1.11426C0.498855 8.91406 0 8.41521 0 7.7998C0 7.1844 0.498855 6.68555 1.11426 6.68555H6.68164V1.11426C6.68164 0.498855 7.1805 0 7.7959 0Z"
                            fill="#8B8B8B"/>
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="invoicing__cart-item" data-license-price="${iec.Price}">
                  <h6 class="gray mb-10">Стоимость, руб</h6>
                  <h5>${(iec.Price * stateCart.count).toLocaleString('ru')}</h5>
                </div>
                <div class="invoicing__cart-item invoicing__cart-item--align-right">
                  <h6 class="gray mb-10">Удалить</h6>
                  <div class="invoicing__basket" data-invoicing-basket="${iec.Id}">
                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none"
                         xmlns="http://www.w3.org/2000/svg" >
                      <path
                          d="M10.0267 5.2217e-08C10.3998 9.79738e-05 10.7634 0.119057 11.0661 0.340027C11.3687 0.560997 11.595 0.872775 11.7129 1.2312L12.1956 2.7H15.1111C15.3469 2.7 15.573 2.79482 15.7397 2.9636C15.9064 3.13239 16 3.3613 16 3.6C16 3.83869 15.9064 4.06761 15.7397 4.2364C15.573 4.40518 15.3469 4.5 15.1111 4.5L15.1084 4.5639L14.3378 15.4926C14.2897 16.1735 13.9886 16.8108 13.4951 17.276C13.0017 17.7412 12.3525 17.9999 11.6782 18H4.32178C3.64752 17.9999 2.99832 17.7412 2.50486 17.276C2.0114 16.8108 1.71032 16.1735 1.66222 15.4926L0.891555 4.563C0.889947 4.54204 0.889058 4.52102 0.888889 4.5C0.653141 4.5 0.427048 4.40518 0.260349 4.2364C0.0936505 4.06761 0 3.83869 0 3.6C0 3.3613 0.0936505 3.13239 0.260349 2.9636C0.427048 2.79482 0.653141 2.7 0.888889 2.7H3.80444L4.28711 1.2312C4.40506 0.872629 4.6315 0.560747 4.93431 0.339764C5.23712 0.11878 5.60095 -9.09551e-05 5.97422 5.2217e-08H10.0267ZM13.3307 4.5H2.66933L3.43556 15.3639C3.45151 15.5909 3.5518 15.8033 3.71623 15.9585C3.88066 16.1136 4.09703 16.1999 4.32178 16.2H11.6782C11.903 16.1999 12.1193 16.1136 12.2838 15.9585C12.4482 15.8033 12.5485 15.5909 12.5644 15.3639L13.3307 4.5ZM6.22222 7.2C6.43994 7.20003 6.65008 7.28096 6.81278 7.42744C6.97547 7.57393 7.07942 7.77577 7.10489 7.9947L7.11111 8.1V12.6C7.11086 12.8294 7.02411 13.05 6.86858 13.2168C6.71305 13.3836 6.50049 13.484 6.27432 13.4975C6.04815 13.5109 5.82544 13.4364 5.6517 13.2892C5.47797 13.1419 5.36631 12.9331 5.33956 12.7053L5.33333 12.6V8.1C5.33333 7.8613 5.42698 7.63239 5.59368 7.4636C5.76038 7.29482 5.98647 7.2 6.22222 7.2ZM9.77778 7.2C10.0135 7.2 10.2396 7.29482 10.4063 7.4636C10.573 7.63239 10.6667 7.8613 10.6667 8.1V12.6C10.6667 12.8387 10.573 13.0676 10.4063 13.2364C10.2396 13.4052 10.0135 13.5 9.77778 13.5C9.54203 13.5 9.31594 13.4052 9.14924 13.2364C8.98254 13.0676 8.88889 12.8387 8.88889 12.6V8.1C8.88889 7.8613 8.98254 7.63239 9.14924 7.4636C9.31594 7.29482 9.54203 7.2 9.77778 7.2ZM10.0267 1.8H5.97333L5.67733 2.7H10.3227L10.0267 1.8Z"
                          fill="#8B8B8B"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    });
    if (this.invoicingLicenses) {
      this.invoicingLicenses.innerHTML = result;
      const invoicingBasketItems = Array.prototype.slice.call(document.querySelectorAll('[data-invoicing-basket]'));
      invoicingBasketItems.forEach((invoicingBasketItem) => {
        if (this.idsSelectedLicenses.length === 1) {
          invoicingBasketItem.classList.add('disabled');
          return false;
        }
        invoicingBasketItem.addEventListener('click', (e: Event) => {
          e.stopPropagation();
          const deletedLicenseId = invoicingBasketItem.dataset.invoicingBasket;
          if (deletedLicenseId) {
            this.idsSelectedLicenses
              .splice(this.idsSelectedLicenses.indexOf(parseInt(deletedLicenseId, numberSystemDecimal)), 1);
            this.changeShowcaseLicense();
            this.showcaseRender();
            this.changeCardLicense();
            this.cartRender();
          }
        });
      });
    }
    this.cartControlCount();
    this.trackEntryNumberLicenses();
  }

  private trackEntryNumberLicenses() {
    const cartCountControls = Array.prototype.slice.call(document.querySelectorAll('[data-cart-count-control]'));
    const licensePrices = Array.prototype.slice.call(document.querySelectorAll('[data-license-price]'));
    cartCountControls.forEach((ccc: Element, index: number) => {
      const input = ccc.querySelector('input[type="text"]') as HTMLInputElement;
      input.addEventListener('input', () => {
        const result = parseInt(input.value, numberSystemDecimal);

        if (result && result < this.maxInputNumber) {
          const cartCountControlItem = ccc as HTMLElement;
          const params = {
            inputVisible: input,
            result,
            licensePrices,
            index,
            licenseId: parseInt(cartCountControlItem.dataset.cartCountControl!, numberSystemDecimal),
          };

          this.showTotalLicense(params);
        }
      });
    });
  }

  private cartControlCount() {
    const cartCountControls = Array.prototype.slice.call(document.querySelectorAll('[data-cart-count-control]'));
    const licensePrices = Array.prototype.slice.call(document.querySelectorAll('[data-license-price]'));

    cartCountControls.forEach((ccc: Element, index: number) => {
      const minus = ccc.querySelector('[data-lisense-minus]');
      const plus = ccc.querySelector('[data-lisense-plus]');
      const inputVisible = ccc.querySelector('input[type="text"]') as HTMLInputElement;
      const cartCountControlItem = ccc as HTMLElement;

      if (inputVisible) {
        if (minus) {
          minus.addEventListener('click', (e) => {
            if (parseInt(inputVisible.value, numberSystemDecimal) > 1) {

              const result = parseInt(inputVisible.value, numberSystemDecimal) - 1;
              if (result < this.maxInputNumber) {
                const params = {
                  inputVisible,
                  result,
                  licensePrices,
                  index,
                  licenseId: parseInt(cartCountControlItem.dataset.cartCountControl!, numberSystemDecimal),
                };
                this.showTotalLicense(params);
              }
            }
          });
        }
        if (plus) {
          plus.addEventListener('click', (e) => {
            if (parseInt(inputVisible.value, numberSystemDecimal) < maximumNumber) {
              const result = parseInt(inputVisible.value, numberSystemDecimal) + 1;
              if (result < this.maxInputNumber) {
                const params = {
                  inputVisible,
                  result,
                  licensePrices,
                  index,
                  licenseId: parseInt(cartCountControlItem.dataset.cartCountControl!, numberSystemDecimal),
                };
                this.showTotalLicense(params);
              }
            }
          });
        }
      }
    });
  }

  private showTotalLicense(params: {
                     inputVisible: HTMLInputElement;
                     result: number;
                     licensePrices: HTMLElement[];
                     index: number;
                     licenseId: number;
                   }
  ) {
    params.inputVisible.value = String(params.result);
    if (params.licensePrices.length > 0) {
      const licensePriceValue = params.licensePrices[params.index]?.dataset.licensePrice;
      if (licensePriceValue) {
        const priceDisplay = params.licensePrices[params.index].querySelector('h5');
        const stateBasketItem = this.stateCartItems.find(sbi => sbi.id === params.licenseId);
        if (stateBasketItem) {
          stateBasketItem.count = parseInt(params.inputVisible.value, numberSystemDecimal);
          stateBasketItem.price = Math.abs(parseInt(licensePriceValue, numberSystemDecimal))
            * parseInt(params.inputVisible.value, numberSystemDecimal);
        }
        if (priceDisplay) {
          priceDisplay.innerText = Math.abs((parseInt(licensePriceValue, numberSystemDecimal))
            * parseInt(params.inputVisible.value, numberSystemDecimal)
          ).toLocaleString('ru');
        }
      }
    }
    this.displayTotalPrice();
  }

  private renderInvoicingLicenses() {
    this.invoicingService.getInvoiceLicense()
      .then((response: InterfaceInvoiceLicense[] | null) => {
        if (response) {
          const licenseId = searchParams.get('licenseId');
          if (licenseId) {
            this.invoicingShowcaseItems = structuredClone(response);
            this.idsSelectedLicenses = [parseInt(licenseId, numberSystemDecimal)];
            this.changeShowcaseLicense();
            this.showcaseRender();
            this.changeCardLicense();
            this.cartRender();
          }
        } else {
          if (this.modal) {
            new ModalComponent(this.modal, null,'application-server-error').initialize();
          }
        }
      });
  }

  private validateInn(inn: string | number) {
    const str = String(inn);
    if (!/^\d+$/.test(str)) {return false;}
    if (/^0+$/.test(str)) {return false;}

    const length = str.length;
    let checkDigit = false;

    if (length === 10) {
      // Юридическое лицо
      const n10 = String(this.calculateCheckDigit(str, [2, 4, 10, 3, 5, 9, 4, 6, 8]));
      checkDigit = n10 === str[9];
    } else if (length === 12) {
      // Физическое лицо / ИП
      const n11 = String(this.calculateCheckDigit(str, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]));
      const n12 = String(this.calculateCheckDigit(str, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]));
      checkDigit = (n11 === str[10] && n12 === str[11]);
    }

    return checkDigit;
  }
  private validateCorrectKpp(kpp: number | string) {
    const str = String(kpp);
    if (/^0+$/.test(str)) {return false;}
    return /^\d{4}[\dA-Z]{2}\d{3}$/.test(str);
  }
  private validateReasonCode(kpp: number | string) {
    const pp = String(kpp).substring(4, 6);
    if (/^\d{2}$/.test(pp)) {
      const ppNum = parseInt(pp, 10);
      if (ppNum < 1 || ppNum > 99) {
        return false
      }
    }
    return true
  }
  private calculateCheckDigit(str: string, coefficients: number[]) {
    let sum = 0;
    for (let i = 0; i < coefficients.length; i++) {
      sum += parseInt(str[i]) * coefficients[i];
    }
    return sum % 11 % 10;
  }
}
